import { ContentfulComponentCardDeck } from 'graphqlTypes';
import { FC } from 'react';

import MinimalCardDeckSlider from 'components/CardDeck/MinimalCardDeck/MinimalCardDeckSlider';
import MinimalCardDeckStatic from 'components/CardDeck/MinimalCardDeck/MinimalCardDeckStatic';

interface MinimalCardDeckProps extends ContentfulComponentCardDeck {
  isSlider?: boolean;
}

const MinimalCardDeck: FC<MinimalCardDeckProps> = ({ isSlider, ...otherProps }) =>
  isSlider ? <MinimalCardDeckSlider {...otherProps} /> : <MinimalCardDeckStatic {...otherProps} />;

export default MinimalCardDeck;
